/**
 * Where every "book a call" link on the site and in the app goes: the Brew
 * demo booking page on Cal.com. One constant so the link can never drift
 * between the home page, the pricing page, the FAQ, and the app's
 * Enterprise and founder calls-to-action.
 */
export const BREW_DEMO_BOOKING_URL = 'https://cal.com/team/brewdotnew/brew-demo'
